import {
	setClientId,
	setPasses,
	setPerson,
	setReplacedPersonId,
	setUser,
	showActiveBooking,
} from '@/store/user-process/user-process';

import { queryClient } from '@/shared/api/queryClient';
import { getAuthProvider, setAuthProvider } from '@/shared/helpers/keycloak';
import useUserStore from '@/shared/store/user.store.ts';

import { store } from '../store';

export const resetAuth = (withRedirect = true) => {
	useUserStore.getState().reset();
	queryClient.clear();

	store.dispatch(setUser(null));
	store.dispatch(setPerson(null));
	store.dispatch(setClientId(null));
	store.dispatch(setReplacedPersonId(null));
	store.dispatch(setPasses(null));
	store.dispatch(showActiveBooking(false));

	// Признак способа входа переживает сброс — по нему /login решает, запускать ли авто-SSO
	const authProvider = getAuthProvider();

	localStorage.clear();
	sessionStorage.clear();

	if (authProvider) {
		setAuthProvider(authProvider);
	}

	if (withRedirect) {
		window.location.replace('/');
	}
};
